/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Tab_VisualInputs */

const cs_builder_tab_visual = /** @type {(inputs: Builder_Tab_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizuální`)
};

const en_builder_tab_visual = /** @type {(inputs: Builder_Tab_VisualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visual`)
};

/**
* | output |
* | --- |
* | "Visual" |
*
* @param {Builder_Tab_VisualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_tab_visual = /** @type {((inputs?: Builder_Tab_VisualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Tab_VisualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_tab_visual(inputs)
	return cs_builder_tab_visual(inputs)
});